export default __webpack_public_path__ + "static/media/Nativa_Logo.4387f563.png";